import DashboardLayout from 'src/pages/Layout/DashboardLayout.vue'
import NotFound from 'src/pages/GeneralViews/NotFoundPage.vue'

import Overview from 'src/pages/Overview/Index.vue'

/* guest */

import authRoutes from './routes/auth'

/* admin */

import statsRoutes from './routes/stats'

/* lager & admin */

// stammdaten
import settingsRoutes from './routes/settings'
import usersRoutes from './routes/users'
import unitsRoutes from './routes/units'
import causesRoutes from './routes/causes'
import costCentersRoutes from './routes/costCenters'
import productCategoriesRoutes from './routes/productCategories'

import boxesRoutes from './routes/boxes'
import productRoutes from './routes/products'

/* all */

import suppliersRoutes from './routes/suppliers'
import supplierContactPeopleRoutes from './routes/supplierContactPeople'
import supplierProductsRoutes from './routes/supplierProducts'
import warehousesRoutes from './routes/warehouses'
import warehouseProductsRoutes from './routes/warehouseProducts'
import stockRotationsRoutes from './routes/stockRotations'
import ordersRoutes from './routes/orders'
import labelsRoutes from './routes/labels'
import inventoryRoutes from './routes/inventory'
import warehouseConfigRoutes from './routes/warehouseConfig'
import productsConfigRoutes from './routes/productConfig'
import locationsRoutes from './routes/locations'
import locationProductRoutes from './routes/locationProducts'
import collectiveBookings from './routes/collectiveBookings'

import UserSettingsEdit from 'src/pages/UserSettings/Edit.vue'

const auth = { requiresAuth: true }

const routes = [
  {
    path: '/',
    component: DashboardLayout,
    children: [
      {
        path: '/',
        name: 'Lagerbewegung Erfassen',
        component: Overview,
        meta: auth
      },
      ...usersRoutes,
      ...productRoutes,
      ...productCategoriesRoutes,
      ...suppliersRoutes,
      ...supplierContactPeopleRoutes,
      ...warehousesRoutes,
      ...unitsRoutes,
      ...warehouseProductsRoutes,
      ...stockRotationsRoutes,
      ...causesRoutes,
      ...costCentersRoutes,
      ...ordersRoutes,
      ...supplierProductsRoutes,
      ...labelsRoutes,
      ...statsRoutes,
      ...inventoryRoutes,
      ...boxesRoutes,
      ...settingsRoutes,
      ...warehouseConfigRoutes,
      ...productsConfigRoutes,
      ...locationsRoutes,
      ...locationProductRoutes,
      ...collectiveBookings,
      {
        path: '/user_settings',
        name: 'User Einstellungen',
        component: UserSettingsEdit,
        meta: auth
      }
    ]
  },
  ...authRoutes,
  { path: '*', component: NotFound }
]

export default routes
